var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.398 13.5a.75.75 0 0 1-.547-.236L3.204 9.379a.75.75 0 1 1 1.092-1.026l3.094 3.293 6.306-6.902a.75.75 0 0 1 1.108 1.011l-6.853 7.5a.748.748 0 0 1-.548.245h-.005Z",
    fill: "#76B900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "TickIcon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 4,
    width: 12,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.398 13.5a.75.75 0 0 1-.547-.236L3.204 9.379a.75.75 0 1 1 1.092-1.026l3.094 3.293 6.306-6.902a.75.75 0 0 1 1.108 1.011l-6.853 7.5a.748.748 0 0 1-.548.245h-.005Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#TickIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#76B900",
    d: "M0 0h18v18H0z"
  }))));
};
export default SvgTickIcon;